// extracted by mini-css-extract-plugin
export default {"uploadButton":"styles_uploadButton__Nj5Vl"};